import store from './store';
// ---- local imports ------

// #262, added skip mission to commands in cypress
if (window.Cypress) {
	window.store = store;
}

export * from './selectors';
export * from './actions';

export default store;
